
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { Website, WebsiteCreationAction } from '@/services/Website/interfaces';

@Component({
  mixins: [Themeable],
})
export default class UpdateWebsiteActionStatusDialog extends Vue {
  @Prop() public status!: string;

  @Prop() public action!: WebsiteCreationAction;

  public visible: boolean = true;

  public recreateWebsite(): void {
    this.$emit('updateActionStatus', this.action.id, this.status);
    this.destroyComponent();
  }

  public destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }

  public transformActionName(name: string): string {
    return name.replaceAll('_', ' ').toUpperCase();
  }
}
